// ABOUTME: Turns a widget's fractional `width` into the CSS width of its layout cell.
// ABOUTME: The cell gives up its share of the row gap and its own horizontal margins, so `width` is the share of the row it occupies.

/**
 * The CSS width of a widget cell whose `width` is the fraction `fraction` of the row. A row's
 * widgets are separated by `gap` and pushed apart by their horizontal margins, which a plain
 * percentage would add on top: then two widgets at 0.5 no longer fit side by side. Each cell gives
 * up `gap * (1 - fraction)` (summing to the gaps of any row whose fractions add up to 1) and its own
 * left and right margins, so 0.25 is exactly a quarter of the row, spacing included.
 * `gap` and `marginX` are CSS lengths; `marginX` is the sum of the left and right margins.
 */
export function widgetCellWidth(fraction: number, gap: string, marginX: string): string {
    const percentage = `${Number((fraction * 100).toFixed(4))}%`;
    const gapShare = Number((1 - fraction).toFixed(4));
    const deductions = [
        gapShare > 0 && parseFloat(gap) !== 0 ? `${gap} * ${gapShare}` : undefined,
        parseFloat(marginX) !== 0 ? marginX : undefined,
    ].filter((part): part is string => part !== undefined);
    return deductions.length === 0 ? percentage : `calc(${percentage} - ${deductions.join(' - ')})`;
}
